module.exports = __webpack_public_path__ + "static/newsletter-ffc2cccd4c6c180e9aa95f9d21336ba7.svg";